import { useEffect, useState } from "react";
import { api, mxn, formatApiError } from "@/lib/api";
import { Modal, Btn, Select, Input, CreatableSelect } from "@/components/Kit";
import { toast } from "sonner";

// Formulario/lógica de pago compartido por Cobranza ("Cobrar") y Facturas ("Aplicar pago").
export function PaymentModal({ open, onClose, target, editPay, prefill, banks = [], onCreateBank, onSaved }) {
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState("Transferencia");
  const [date, setDate] = useState("");
  const [bank, setBank] = useState("");
  const [reference, setReference] = useState("");
  const [notes, setNotes] = useState("");

  useEffect(() => {
    if (!open) return;
    if (editPay) {
      setAmount(String(editPay.amount));
      setMethod(editPay.method || "Transferencia");
      setDate((editPay.date || "").slice(0, 10) || new Date().toISOString().slice(0, 10));
      setBank(editPay.bank || "");
      setReference(editPay.reference || "");
      setNotes(editPay.notes || "");
    } else {
      setAmount(target?.balance != null ? String(target.balance) : "");
      setMethod(prefill?.method || "Transferencia");
      setDate((prefill?.date || "").slice(0, 10) || new Date().toISOString().slice(0, 10));
      setBank(prefill?.bank || "");
      setReference(prefill?.reference || "");
      setNotes(prefill?.notes || "");
    }
  }, [open, editPay, target, prefill]);

  const submit = async (e) => {
    e.preventDefault();
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) return toast.error("Monto inválido");
    if (!date) return toast.error("Fecha de pago requerida");
    const showBank = method !== "Efectivo";
    const payload = {
      amount: amt,
      method,
      date,
      bank: showBank ? bank : "",
      reference,
      notes,
    };
    if (target?.type === "remision") payload.remision_id = target.id;
    else payload.invoice_id = target.id;
    try {
      if (editPay) {
        await api.put(`/payments/${editPay.id}`, payload);
        toast.success("Pago actualizado");
      } else {
        await api.post("/payments", payload);
        toast.success("Pago registrado");
      }
      onClose();
      onSaved?.();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <Modal open={open} onClose={onClose} title={`${editPay ? "Editar cobro" : "Registrar cobro"} · ${target?.number || ""}`}>
      <form onSubmit={submit} className="space-y-4">
        <div className="font-mono-data text-sm text-[#5C5A55]">
          {editPay ? "Editando pago registrado" : <>Saldo pendiente: <span className="text-[#ED1F26]">{mxn(target?.balance || 0)}</span></>}
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Input label="Monto *" type="number" step="any" value={amount} onChange={(e) => setAmount(e.target.value)} testid="collect-amount" required />
          <Input label="Fecha de pago *" type="date" value={date} onChange={(e) => setDate(e.target.value)} testid="collect-date" required />
        </div>
        <Select label="Método" value={method} onChange={(e) => setMethod(e.target.value)} testid="collect-method">
          <option>Transferencia</option><option>Efectivo</option><option>Tarjeta</option><option>Cheque</option>
        </Select>
        {method !== "Efectivo" && (
          <CreatableSelect
            label="Banco / dato de pago"
            value={bank}
            onChange={setBank}
            options={banks}
            onCreate={onCreateBank}
            placeholder="Selecciona banco…"
            addLabel="➕ Agregar nuevo banco…"
            newPlaceholder="Nuevo banco / dato…"
            testid="collect-bank"
          />
        )}
        <Input label="Referencia / folio de transferencia" value={reference} onChange={(e) => setReference(e.target.value)} testid="collect-reference" />
        <label className="block">
          <span className="overline block mb-1.5">Notas / dato adicional</span>
          <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} data-testid="collect-notes"
            className="w-full bg-[#FFFFFF] border border-[#E3E8EE] px-3 py-2 font-mono-data text-sm text-[#1C1A17] focus:outline-none focus:ring-1 focus:ring-[#465B7F] focus:border-[#465B7F]" />
        </label>
        <div className="flex justify-end gap-3">
          <Btn variant="ghost" type="button" onClick={onClose}>Cancelar</Btn>
          <Btn type="submit" data-testid="confirm-collect-button">{editPay ? "Guardar cambios" : "Registrar cobro"}</Btn>
        </div>
      </form>
    </Modal>
  );
}
